import { SVGProps, Ref, forwardRef } from 'react';

export const EyeCrossedOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2.5C3.5 2.5.333 6.625 0 8c.154.636.915 1.861 2.134 2.994L.586 13.057l1.12.84L3.22 11.88a9.3 9.3 0 0 0 2.044 1.105L4.72 15.16l1.358.34.533-2.132a7.4 7.4 0 0 0 2.774 0l.533 2.132 1.358-.34-.543-2.175a9.3 9.3 0 0 0 2.044-1.104l1.513 2.016 1.12-.84-1.546-2.061C15.084 9.863 15.846 8.636 16 8c-.333-1.375-3.5-5.5-8-5.5m0 9.6c-1.811 0-3.416-.832-4.648-1.895a9.2 9.2 0 0 1-1.455-1.579A6 6 0 0 1 1.505 8a6 6 0 0 1 .392-.626 9.2 9.2 0 0 1 1.455-1.58C4.584 4.734 6.189 3.9 8 3.9s3.416.833 4.648 1.895a9.2 9.2 0 0 1 1.455 1.579c.18.254.308.465.392.626-.084.16-.211.372-.392.626a9.2 9.2 0 0 1-1.455 1.58C11.416 11.267 9.811 12.1 8 12.1"
                fill="currentColor"
            />
        </g>
    </svg>
));
EyeCrossedOutlinedSize16Glyph.displayName = 'EyeCrossedOutlinedSize16Glyph';
